import { render, staticRenderFns } from "./courseCategory.vue?vue&type=template&id=32495fe7&scoped=true&"
import script from "./courseCategory.vue?vue&type=script&lang=js&"
export * from "./courseCategory.vue?vue&type=script&lang=js&"
import style0 from "./courseCategory.vue?vue&type=style&index=0&id=32495fe7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32495fe7",
  null
  
)

export default component.exports